module.exports = __webpack_public_path__ + "img/company3.d25b38c6.png";